<template>
  <div class="login">
    <div class="left-panel">
      <h1>WELCOME TO <span class='subtext'>THE</span> BENJAMIN MOORE PORTABLE MATERIALS PORTAL</h1>
    </div>
    <div class="right-panel">
      <img class="bm-logo" src="../../src/assets/images/BMM_Color.png" />
      <form action class="login-form" @submit.prevent="login">
        <div class="login-container">
          <h2>Sign in</h2>
          <input v-model="email" type="email" name="email" id="email" placeholder="Email address" />
          <input
            v-model="password"
            type="password"
            name="password"
            id="password"
            placeholder="Password"
          />
          <h3>
            <span style="cursor:pointer;" @click="forgotPass">FORGOT PASSWORD</span>
          </h3>
        </div>
        <button class="login-btn" type="submit" value="Login" :disabled="disabled || !email || !password">
          LOGIN
        </button>
      </form>
    </div>
     <modal class="modal-screens" v-show="isModalOpen">
            <template v-slot:header>
              <div>{{modalHeader}}</div>
            </template>
            <template v-slot:body>
              <div class="app-modal" v-if="modalType == 'forgotPass'">
                <input v-model="forgotEmail" placeholder="Email address" />
              </div>
              <div class="app-modal" v-if="modalType == 'newPass'">
                <input type="password" v-model="newPass" placeholder="New Password" style="margin-bottom: 20px;" />
                <input type="password" v-model="confirmNewPass" placeholder="Confirm New Password" />
              </div>
              <div class="app-modal" v-else-if="modalType =='successful'">
                <h3>{{modalSuccess}}</h3>
              </div>
            </template>
            <template v-slot:footer>
        <button :disabled="(modalType == 'newPass' && !passwordValid) || (modalType == 'forgotPass' && forgotEmail == '')" @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button @click="closeModal">CANCEL</button>
      </template>
          </modal>
  </div>
</template>

<script>
import { LOGIN } from "@/store/actions.type";
import Modal from "@/components/Modal.vue";
import { RECOVER_PASSWORD, RECOVER_PASSWORD_CODE } from "@/store/actions.type";


export default {
  components: {
    Modal
    },
  data() {
    return {
      email: null,
      password: null,
      error: null,
      disabled: false,
      isModalOpen: false,
      modalHeader: "",
      forgotEmail: "",
      modalType: "",
      code: "",
      newPass: "",
      confirmNewPass: "",
      modalSuccess: ""
    };
  },
  methods: {
    login() {
      const loader = this.$loading.show();
      this.disabled = true;
      this.error = null;
      this.$store
        .dispatch(LOGIN, {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$router.push(
            this.$route.query.redirect ? this.$route.query.redirect : "/"
          );
          loader.hide();
        })
        .catch(err => {
          this.$notify({
              text: 'The email or password you entered is not valid. Please try again.',
              classes: 'vue-notification',
              position: 'top center',
              type: 'error'
            })
          this.error = err;
          this.disabled = false;
          loader.hide();
        });
    },
    forgotPass() {
      this.isModalOpen = true;
      this.disabled = true;
      this.modalHeader ="Forgot Password";
      this.modalType = "forgotPass";
    },
    recoverPass() {
      if(this.$route.query.code){
      this.disabled = true;
      this.isModalOpen = true;
      this.modalHeader = "Change Password";
      this.modalType = "newPass";
      this.code = this.$route.query.code;
      }
    },
    commit() {
      const loader = this.$loading.show();
      if (this.modalType == "forgotPass") {
        this.$store
          .dispatch(RECOVER_PASSWORD, this.forgotEmail)
          .then(() => {
            this.$notify({
              text: 'Recovery Code Sent to email',
              classes: 'vue-notification',
              position: 'top center',
              type: 'success'
            })
            this.forgotEmail = "";
            this.isModalOpen = false;
            this.disabled = false;
            loader.hide();
          })
          .catch(err => {
            this.error = err;
            loader.hide();
          });
      } else if (this.modalType == "newPass") {
        this.$store
          .dispatch(RECOVER_PASSWORD_CODE, {
            code: this.code,
            password: this.newPass
          })
          .then(() => {
            this.$notify({
              text: 'Password Updated',
              classes: 'vue-notification',
              position: 'top center',
              type: 'success'
 
            })
            this.isModalOpen = false;
            this.disabled = false;
            this.newPass = "";
            this.confirmNewPass = "";
            loader.hide();
          })
          .catch(err => {
            this.$notify({
              text: 'Password Update Failed',
              classes: 'vue-notification',
              position: 'top center',
              type: 'error'
            })
            this.error = err;
            loader.hide();
          });
      } else {
        this.disabled = false;
        loader.hide();
        this.closeModal();
      }
    },
    closeModal() {
      this.forgotEmail = "";
      this.newPass = "";
      this.confirmNewPass = "";
      this.disabled = false;
      this.isModalOpen = false;
    }
  },
  computed: {
    passwordValid(){
      return this.newPass != "" && this.confirmNewPass != "" && this.newPass == this.confirmNewPass;
    }
  },
  created(){
    this.recoverPass();
  }
};
</script>

<style lang="scss" scoped>
.left-panel {
  width: 43%;
  background-color: white;
  display: flex;
}

h1 {
  margin: auto 0 auto 64px;
  width: 370px;
  font-size: 50px;
  .subtext{
    font-size: 34px;
  }
}

h2 {
  font-size: 20px;
  margin: 30px 0px;
  font-family: "Proxima SemiBold"
}

h3 {
  margin: 0;
  font-size: 12px;
  color: #2266bb;
  font-weight: 600;
  padding-bottom: 29px;
}

.right-panel {
  display: flex;
  flex-direction: column;
  margin: auto auto;
}

.login {
  display: flex;
  width: 100%;
}

.login-form {
  display: flex;
  flex-direction: column;
  width: 405px;
  height: 306px;
  color: #454545;
  justify-content: space-between;
}

.bm-logo {
  padding-bottom: 31px;
}

.login-btn {
    background-color: #2266BB;
    color: white;
    font-size: 12px;
    font-weight: 600;
    margin: 33px auto 0;
}

.login-container {
  display: flex;
  flex-direction: column;
  background: white;
}
</style>